import { Link } from "react-router-dom";
import SubscribeForm from "../SubscribeForm";

export function AboutInvitation() {
  return (
    <section data-testid="about-invitation" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[28px] md:pt-[39px] pb-[54px] md:pb-[76px] reveal">
        <div className="max-w-[600px] mx-auto text-center">
          <p className="font-display text-[32px] md:text-[43px] text-[#159E9A] leading-[1.3]">
            That&rsquo;s the version of me you get before the credentials and
            the client results.
          </p>
          <p className="text-lg md:text-xl leading-relaxed text-[#57534E] mt-[15px]">
            The one who builds snowmen too big, laughs too long, and still
            keeps a journal that says <em>dream</em> on the cover.
          </p>
          <p
            data-testid="about-invitation-line"
            className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug mt-[19px]"
          >
            If this feels like the start of a conversation rather than
            the end of a page — good.
            <br />
            That was the idea.
          </p>

          <div className="mt-[29px] flex flex-col sm:flex-row items-center justify-center gap-6 text-base">
            <Link
              to="/work-with-me"
              data-testid="about-invitation-work-with-me"
              className="text-[#1C1917] font-medium underline-offset-4 hover:underline hover:text-[#FF5A4F] transition-colors"
            >
              How we might work together →
            </Link>
            <Link
              to="/this-curious-life"
              data-testid="about-invitation-curious-life"
              className="text-[#1C1917] font-medium underline-offset-4 hover:underline hover:text-[#FF5A4F] transition-colors"
            >
              A few more field notes →
            </Link>
          </div>

          <div className="mt-[33px] pt-[24px] border-t border-[#E8E6E3]">
            <p className="text-sm text-[#57534E] mb-5">
              Or just leave your email. I&rsquo;ll keep it short and I&rsquo;ll
              keep it honest.
            </p>
            <div className="max-w-[420px] mx-auto">
              <SubscribeForm source="about_page" testIdPrefix="about-subscribe" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
